export default __webpack_public_path__ + "static/media/tytnomina.a095cbd7.png";